import { render, staticRenderFns } from "./ActividadesGrid.vue?vue&type=template&id=96e88fd6&"
import script from "./ActividadesGrid.vue?vue&type=script&lang=ts&"
export * from "./ActividadesGrid.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/portal-track3/portal-track3/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('96e88fd6', component.options)
    } else {
      api.reload('96e88fd6', component.options)
    }
    module.hot.accept("./ActividadesGrid.vue?vue&type=template&id=96e88fd6&", function () {
      api.rerender('96e88fd6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pantallas/Inicio/ActividadesGrid/ActividadesGrid.vue"
export default component.exports